import { useMutation } from '@tanstack/react-query';

import {
  IChannel,
  useInvalidateChannelById,
  useInvalidateChannelsList,
} from '@/entities/channel';
import { useInvalidateAllCompanyChannels } from '@/entities/company';
import { deleteBotTokenByChannelId } from '@/shared/api/channels';
import { useNotifications } from '@/shared/ui/Notifications';

export function useDeleteBotToken() {
  const invalidateChannelsList = useInvalidateChannelsList();
  const invalidateChannelById = useInvalidateChannelById();
  const invalidateAllCompanyChannels = useInvalidateAllCompanyChannels();
  const { addNotification } = useNotifications();

  const deleteBotTokenMutation = useMutation({
    mutationFn: (channelId: string) => deleteBotTokenByChannelId(channelId),
    onSuccess: async (data) => {
      await invalidateChannelsList();
      await invalidateChannelById(data.id);
      await invalidateAllCompanyChannels();
    },
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const deleteBotToken = async (
    channelId: string,
    onDeleted?: (channel: IChannel) => void
  ): Promise<IChannel> => {
    return deleteBotTokenMutation.mutateAsync(channelId, {
      onSuccess: onDeleted,
    });
  };

  return { deleteBotToken, ...deleteBotTokenMutation };
}
